import { all } from 'redux-saga/effects';

import appSaga from './modules/app/sagas';
import userSaga from './modules/users/sagas';
import authSaga from './modules/auth/sagas';
import initSaga from './modules/init/sagas';
import organizationSaga from './modules/organizations/sagas';
import customerSaga from './modules/customers/sagas';
import videosSaga from './modules/videos/sagas';
import videoMenusSaga from './modules/video-menus/sagas';
import projectsSaga from './modules/projects/sagas';
import notificationsSaga from './modules/notifications/sagas';
import registerSaga from './modules/registration/sagas';
import passwordRecoverySaga from './modules/password-recovery/sagas';
import userPermissionsSaga from './modules/user-permissions/sagas';
import listSaga from './modules/lists/sagas';
import sceneSaga from './modules/scenes/sagas';
import studioSaga from './modules/studio/sagas';
import documentsSaga from './modules/documents/sagas';
import articleSaga from './modules/articles/sagas';
import articleCommentsSaga from './modules/articleComments/sagas';
import scriptEditorSaga from './modules/script-editor/sagas';
import promotionCodesSaga from './modules/promotion-codes/sagas';
import phoneVerification from './modules/phone-verification/sagas';
import mediaViewer from './modules/media-viewer/sagas';
import productSaga from './modules/products/sagas';
import billingSaga from './modules/billing/sagas';
import creditsSaga from './modules/credits/sagas';
import ordersSaga from './modules/orders/sagas';

export default function* rootSaga() {
  yield all([
    ...appSaga,
    ...initSaga,
    ...authSaga,
    ...customerSaga,
    ...organizationSaga,
    ...projectsSaga,
    ...userSaga,
    ...videosSaga,
    ...videoMenusSaga,
    ...registerSaga,
    ...passwordRecoverySaga,
    ...userPermissionsSaga,
    ...listSaga,
    ...sceneSaga,
    ...studioSaga,
    ...documentsSaga,
    ...articleSaga,
    ...scriptEditorSaga,
    ...articleCommentsSaga,
    ...notificationsSaga,
    ...promotionCodesSaga,
    ...phoneVerification,
    ...mediaViewer,
    ...productSaga,
    ...billingSaga,
    ...creditsSaga,
    ...ordersSaga,
  ]);
}
